module.exports = __webpack_public_path__ + "img/multiple-users.10348536.svg";